//namespace Pacem.Compile.Markdown {
import { NullChecker } from "../../null-checker";
import * as Compile from "../parser";
// #region HELPERS
function htmlEncode(input) {
    return (input ?? '').replace(/</g, '&lt;');
}
function extractReference(input) {
    if (NullChecker.isNullOrEmpty(input)) {
        return void 0;
    }
    if (/^\(/.test(input) && /\)$/.test(input)) {
        return void 0;
    }
    if (/^\[/.test(input) && /\]$/.test(input)) {
        input = input.substr(1, input.length - 2);
    }
    return input;
}
function regexMatchIndex(arr) {
    return arr?.index || void 0;
}
function extractUrl(input) {
    if (NullChecker.isNullOrEmpty(input)) {
        return void 0;
    }
    if (/^\[/.test(input) && /\]$/.test(input)) {
        return void 0;
    }
    if (/^\(/.test(input) && /\)$/.test(input)) {
        input = input.substr(1, input.length - 2);
    }
    return input;
}
function normalizeReference(input) {
    return input?.replace(/[^\w]+/g, ' ').trim().replace(/ +/g, '-').toLowerCase();
}
function match(input, pattern, fn) {
    const arr = pattern.exec(input);
    if (arr && arr.length) {
        return fn(arr);
    }
    return null;
}
// #endregion
const COMMENT = /(<!--)([\s\S]*?)(-->|$)/;
const HR = /^ {0,3}(={3,}|_{3,}|-{3,})(\r?\n|$)/;
const HEADING = /^ {0,3}(#{1,6})\s+([^\n]+)(\r?\n|$)+/;
const HEADING1 = /^ {0,3}([^\n]+)(\r?\n=+(\r?\n|$))+/;
const HEADING2 = /^ {0,3}([^\n]+)(\r?\n-+(\r?\n|$))+/;
const CODEBLOCK = /^ {4,}.+(\r?\n {4,}.+)*(\r?\n|$)+/;
const FENCES = /^ {0,3}``` *([^\n]*)\r?\n(([\s\S](?!\r?\n {0,3}```))*.(\r?\n)+) {0,3}```(\r?\n|$)+/;
const BLOCKQUOTE = /^ {0,3}> *([^\n]+)(\r?\n {0,3}> *([^\n]*))*(\r?\n|$)+/;
const ULIST = /^( {0,3}([-+]).*\r?\n|$)((?!(?: {0,3}(?:\d+[.\)]|\r?\n\S))).*(\r?\n|$))*/;
const OLIST = /^( {0,3}(\d+[.\)]).*\r?\n|$)((?!(?: {0,3}(?:[+-]|\r?\n\S))).*(\r?\n|$))*/;
const LISTITEM = /^(?:[-+*]|\d+[.\)])/m;
const PARAGRAPH = /^(?! {4,})(.+(\n(?! {0,3}```)(?! {0,3}([-+]|\d+[.\)]))(?! {4,})(?! {0,3}>).+)*)/;
const REF = /^ {0,3}(!?)\[([^\]]+)\]: +(\S+)(?: +['"\(](.+)['"\)])?(\r?\n|$)+/;
const IMAGE_OR_LINK = /!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?(\[[^\[\]]*\]|\([^\(\)]*\))?/;
const EMPHASIZED_LINK = /(\*\*?|__?)(\[[^\]]*]\([^\)]+\))\1/;
const CODE = /(?:(?<!\\)`)(.+?)(?:(?<!\\)`)/;
const EMPHASIZE = /(\*\*?|__?)((?!\1\s?)(?:(?!\1)[\S\s])*[^\s])\1/;
const STRIKE = /(~~?|__?)(?!\1\s?)([^\s][\s\S]*?(?!\1)[^\s])\1/;
const QUOTE = /(:")(?!":\s?)([^\s][\s\S]*?(?!":)[^\s])":/;
const SPACE = /^\s+/;
const LINEBREAK = / {2,}\r?\n/;
const TEXT = /^[^\r\n]+/;
var MARKDOWN_TYPES;
(function (MARKDOWN_TYPES) {
    MARKDOWN_TYPES["Html"] = "html";
    MARKDOWN_TYPES["Text"] = "text";
    MARKDOWN_TYPES["Paragraph"] = "paragraph";
    MARKDOWN_TYPES["BlockQuote"] = "blockquote";
    MARKDOWN_TYPES["Space"] = "space";
    MARKDOWN_TYPES["Heading"] = "heading";
    MARKDOWN_TYPES["Bold"] = "bold";
    MARKDOWN_TYPES["Italic"] = "italic";
    MARKDOWN_TYPES["CodeBlock"] = "codeblock";
    MARKDOWN_TYPES["Code"] = "code";
    MARKDOWN_TYPES["Image"] = "img";
    MARKDOWN_TYPES["ImageLike"] = "imglike";
    MARKDOWN_TYPES["Link"] = "link";
    MARKDOWN_TYPES["LinkLike"] = "linklike";
    MARKDOWN_TYPES["LineBreak"] = "br";
    MARKDOWN_TYPES["StrikeThrough"] = "strike";
    MARKDOWN_TYPES["Quote"] = "quote";
    MARKDOWN_TYPES["HorizontalRule"] = "hr";
    MARKDOWN_TYPES["OrderedList"] = "ol";
    MARKDOWN_TYPES["UnorderedList"] = "ul";
    MARKDOWN_TYPES["ListItem"] = "listitem";
    MARKDOWN_TYPES["Reference"] = "ref";
})(MARKDOWN_TYPES || (MARKDOWN_TYPES = {}));
var MARKDOWN_RULES;
(function (MARKDOWN_RULES) {
    MARKDOWN_RULES[MARKDOWN_RULES["Comment"] = 0] = "Comment";
    MARKDOWN_RULES[MARKDOWN_RULES["Reference"] = 1] = "Reference";
    MARKDOWN_RULES[MARKDOWN_RULES["HorizontalRule"] = 2] = "HorizontalRule";
    MARKDOWN_RULES[MARKDOWN_RULES["Heading"] = 3] = "Heading";
    MARKDOWN_RULES[MARKDOWN_RULES["Heading1"] = 4] = "Heading1";
    MARKDOWN_RULES[MARKDOWN_RULES["Heading2"] = 5] = "Heading2";
    MARKDOWN_RULES[MARKDOWN_RULES["CodeBlock"] = 6] = "CodeBlock";
    MARKDOWN_RULES[MARKDOWN_RULES["Fences"] = 7] = "Fences";
    MARKDOWN_RULES[MARKDOWN_RULES["BlockQuote"] = 8] = "BlockQuote";
    MARKDOWN_RULES[MARKDOWN_RULES["OrderedList"] = 9] = "OrderedList";
    MARKDOWN_RULES[MARKDOWN_RULES["UnorderedList"] = 10] = "UnorderedList";
    MARKDOWN_RULES[MARKDOWN_RULES["Paragraph"] = 11] = "Paragraph";
    MARKDOWN_RULES[MARKDOWN_RULES["EmphasizedLink"] = 12] = "EmphasizedLink";
    MARKDOWN_RULES[MARKDOWN_RULES["ImageOrLink"] = 13] = "ImageOrLink";
    MARKDOWN_RULES[MARKDOWN_RULES["Emphasize"] = 14] = "Emphasize";
    MARKDOWN_RULES[MARKDOWN_RULES["StrikeThrough"] = 15] = "StrikeThrough";
    MARKDOWN_RULES[MARKDOWN_RULES["Quote"] = 16] = "Quote";
    MARKDOWN_RULES[MARKDOWN_RULES["Code"] = 17] = "Code";
    MARKDOWN_RULES[MARKDOWN_RULES["LineBreak"] = 18] = "LineBreak";
    // lowest priority
    MARKDOWN_RULES[MARKDOWN_RULES["Text"] = 254] = "Text";
    MARKDOWN_RULES[MARKDOWN_RULES["Space"] = 255] = "Space";
})(MARKDOWN_RULES || (MARKDOWN_RULES = {}));
function getGrammar(extra = []) {
    const inert = {
        // comment
        [MARKDOWN_RULES.Comment]: {
            exec: (input, lexer) => match(input, COMMENT, arr => {
                const index = regexMatchIndex(arr);
                const output = [{
                        type: MARKDOWN_TYPES.Html, index, raw: arr[0], text: arr[2]
                    }];
                if (index > 0) {
                    const left = input.substr(0, index), tokens = lexer.tokenize(left, blockRules);
                    Array.prototype.unshift.apply(output, tokens);
                }
                return output;
            })
        },
        // reference
        [MARKDOWN_RULES.Reference]: {
            exec: (input) => match(input, REF, arr => {
                const index = regexMatchIndex(arr), raw = arr[0], text = raw, image = arr[1] === '!', id = arr[2], url = arr[3], title = arr[4];
                return [{
                        type: MARKDOWN_TYPES.Reference, index, raw, text, id, image, url, title
                    }];
            })
        },
    };
    const blockExtra = [], inlineExtra = [], codeExtra = {};
    for (let r of extra) {
        let rule, type = 'inline';
        if ('type' in r) {
            type = r.type;
            rule = r.rule;
        }
        else {
            rule = r;
        }
        switch (type) {
            case 'block':
                blockExtra.push(rule);
                break;
            case 'code':
                if ('lang' in r) {
                    const key = r.lang.toLowerCase();
                    (codeExtra[key] = codeExtra[key] || []).push(rule);
                }
                break;
            default:
                const inlineRule = {
                    exec: (input, lexer) => {
                        const output = rule.exec(input, lexer);
                        inPlaceInlineExec(input, output, lexer);
                        return output;
                    }
                };
                inlineExtra.push(inlineRule);
                break;
        }
    }
    // #region INLINE
    const inlinelowpriority = {
        // text
        [MARKDOWN_RULES.Text]: {
            exec: (input) => match(input, TEXT, arr => {
                const raw = arr[0], text = raw;
                return [{
                        index: regexMatchIndex(arr), raw, text, type: MARKDOWN_TYPES.Text
                    }];
            })
        },
        // sparse lines
        [MARKDOWN_RULES.Space]: {
            exec: (input) => match(input, SPACE, arr => {
                const raw = arr[0];
                return [{
                        type: MARKDOWN_TYPES.Space, raw, text: raw
                    }];
            })
        }
    };
    const inline = {
        // link/image
        [MARKDOWN_RULES.ImageOrLink]: {
            exec: (input, lexer) => inlineMatch(input, IMAGE_OR_LINK, lexer, arr => {
                const index = regexMatchIndex(arr), raw = arr[0], image = raw.charAt(0) === '!', text = arr[1], url = extractUrl(arr[2]), ref = normalizeReference(extractReference(arr[2]) ?? text);
                if (image) {
                    return [{
                            index, type: url ? MARKDOWN_TYPES.Image : MARKDOWN_TYPES.ImageLike,
                            raw, text, src: url, ref,
                            tokens: lexer.tokenize(text, inlineRules)
                        }];
                }
                else {
                    return [{
                            index, type: url ? MARKDOWN_TYPES.Link : MARKDOWN_TYPES.LinkLike,
                            raw, text, href: url, ref,
                            tokens: lexer.tokenize(text, inlineRules)
                        }];
                }
            })
        },
        // code
        [MARKDOWN_RULES.Code]: {
            exec: (input, lexer) => inlineMatch(input, CODE, lexer, arr => {
                const text = htmlEncode(arr[1]);
                return [{
                        type: MARKDOWN_TYPES.Code, raw: arr[0], text, index: regexMatchIndex(arr)
                    }];
            })
        },
        // italic/bold link
        [MARKDOWN_RULES.EmphasizedLink]: {
            exec: (input, lexer) => inlineMatch(input, EMPHASIZED_LINK, lexer, arr => {
                if (arr.length < 3 || NullChecker.isNullOrEmpty(arr[2])) {
                    return null;
                }
                const type = arr[1].length > 1 ? MARKDOWN_TYPES.Bold : MARKDOWN_TYPES.Italic, text = arr[2];
                return [{
                        index: regexMatchIndex(arr),
                        type, raw: arr[0], text, tokens: lexer.tokenize(text, inlineRules)
                    }];
            })
        },
        // italic/bold
        [MARKDOWN_RULES.Emphasize]: {
            exec: (input, lexer) => inlineMatch(input, EMPHASIZE, lexer, arr => {
                if (arr.length < 3 || NullChecker.isNullOrEmpty(arr[2])) {
                    return null;
                }
                const type = arr[1].length > 1 ? MARKDOWN_TYPES.Bold : MARKDOWN_TYPES.Italic, text = arr[2];
                return [{
                        index: regexMatchIndex(arr),
                        type, raw: arr[0], text, tokens: lexer.tokenize(text, inlineRules)
                    }];
            })
        },
        // strike
        [MARKDOWN_RULES.StrikeThrough]: {
            exec: (input, lexer) => inlineMatch(input, STRIKE, lexer, arr => {
                if (arr.length < 3 || NullChecker.isNullOrEmpty(arr[2])) {
                    return null;
                }
                const type = MARKDOWN_TYPES.StrikeThrough, text = arr[2];
                return [{
                        index: regexMatchIndex(arr),
                        type, raw: arr[0], text, tokens: lexer.tokenize(text, inlineRules)
                    }];
            })
        },
        // quote
        [MARKDOWN_RULES.Quote]: {
            exec: (input, lexer) => inlineMatch(input, QUOTE, lexer, arr => {
                if (arr.length < 3 || NullChecker.isNullOrEmpty(arr[2])) {
                    return null;
                }
                const type = MARKDOWN_TYPES.Quote, text = arr[2];
                return [{
                        index: regexMatchIndex(arr),
                        type, raw: arr[0], text, tokens: lexer.tokenize(text, inlineRules)
                    }];
            })
        },
        // line break
        [MARKDOWN_RULES.LineBreak]: {
            exec: (input, lexer) => inlineMatch(input, LINEBREAK, lexer, arr => {
                const raw = arr[0], text = raw;
                return [{
                        index: regexMatchIndex(arr), raw, text, type: MARKDOWN_TYPES.LineBreak
                    }];
            })
        },
    };
    const inPlaceInlineExec = (input, output, lexer) => {
        const index = output?.length > 0 && output[0].index;
        if (index > 0) {
            const left = input.substr(0, index);
            const tokens = lexer.tokenize(left, inlineRules) || [];
            Array.prototype.unshift.apply(output, tokens);
        }
    };
    const inlineMatch = (input, pattern, lexer, fn) => {
        const output = match(input, pattern, arr => {
            if (pattern != CODE) {
                // prioritize code
                const codeCheck = CODE.exec(input);
                if (codeCheck
                    && codeCheck.length
                    && codeCheck.index < arr.index
                // && (codeCheck.index + codeCheck[0].length) > arr.index
                ) {
                    return null;
                }
            }
            return fn(arr);
        });
        inPlaceInlineExec(input, output, lexer);
        return output;
    };
    const inlineRules = Object.values(inline);
    Array.prototype.push.apply(inlineRules, inlineExtra);
    inlineRules.push(inlinelowpriority[MARKDOWN_RULES.Text], inlinelowpriority[MARKDOWN_RULES.Space]);
    // #endregion
    // #region CODE
    const getLangGrammar = (lang) => {
        const retval = [inlinelowpriority[MARKDOWN_RULES.Text], inlinelowpriority[MARKDOWN_RULES.Space]];
        const key = lang?.toLowerCase() || '';
        if (key && key in codeExtra) {
            Array.prototype.unshift.apply(retval, codeExtra[key]);
        }
        return retval;
    };
    // #endregion
    // #region BLOCK
    const lowpriority = {
        // paragraph
        [MARKDOWN_RULES.Paragraph]: {
            exec: (input, lexer) => match(input, PARAGRAPH, arr => {
                const raw = arr[0], text = raw;
                return [{
                        type: MARKDOWN_TYPES.Paragraph, raw, text,
                        // recursion (inline rules only)
                        tokens: lexer.tokenize(text, inlineRules)
                    }];
            })
        },
        // sparse lines
        [MARKDOWN_RULES.Space]: inlinelowpriority[MARKDOWN_RULES.Space]
    };
    const tokenizeListItem = (text, lexer) => {
        const grammar = !/^ {0,3}(`{3,}|$|>|[+-]\s|\d+[.\)])/m.test(text) ? inlineRules : blockRules;
        return lexer.tokenize(text, grammar);
    };
    const block = {
        // hr
        [MARKDOWN_RULES.HorizontalRule]: {
            exec: (input, lexer) => match(input, HR, arr => {
                const raw = arr[0], text = raw;
                return [{
                        type: MARKDOWN_TYPES.HorizontalRule, raw, text
                    }];
            })
        },
        // headings
        [MARKDOWN_RULES.Heading]: {
            exec: (input, lexer) => match(input, HEADING, arr => {
                const text = arr[2];
                return [{
                        type: MARKDOWN_TYPES.Heading, raw: arr[0], text, level: arr[1].length, ref: normalizeReference(text),
                        tokens: lexer.tokenize(text, inlineRules)
                    }];
            })
        },
        [MARKDOWN_RULES.Heading1]: {
            exec: (input, lexer) => match(input, HEADING1, arr => {
                const text = arr[1];
                return [{
                        type: MARKDOWN_TYPES.Heading, raw: arr[0], text, level: 1, ref: normalizeReference(text),
                        tokens: lexer.tokenize(text, inlineRules)
                    }];
            })
        },
        [MARKDOWN_RULES.Heading2]: {
            exec: (input, lexer) => match(input, HEADING2, arr => {
                const text = arr[1];
                return [{
                        type: MARKDOWN_TYPES.Heading, raw: arr[0], text, level: 2, ref: normalizeReference(text),
                        tokens: lexer.tokenize(text, inlineRules)
                    }];
            })
        },
        // codeblock
        [MARKDOWN_RULES.CodeBlock]: {
            exec: (input, lexer) => match(input, CODEBLOCK, arr => {
                const raw = arr[0], text = htmlEncode(raw);
                return [{
                        type: MARKDOWN_TYPES.CodeBlock, raw, text,
                        tokens: lexer.tokenize(text, [])
                    }];
            })
        },
        // codeblock
        [MARKDOWN_RULES.Fences]: {
            exec: (input, lexer) => match(input, FENCES, arr => {
                const text = htmlEncode(arr[2]), lang = arr[1]?.toLowerCase();
                return [{
                        type: MARKDOWN_TYPES.CodeBlock, raw: arr[0], text, lang,
                        tokens: lexer.tokenize(text, getLangGrammar(lang))
                    }];
            })
        },
        // blockquote
        [MARKDOWN_RULES.BlockQuote]: {
            exec: (input, lexer) => match(input, BLOCKQUOTE, arr => {
                const raw = arr[0], text = raw.replace(/^ {0,3}> */gm, '');
                return [{
                        type: MARKDOWN_TYPES.BlockQuote, raw, text,
                        // recursion
                        tokens: lexer.tokenize(text, [
                            lowpriority[MARKDOWN_RULES.Paragraph],
                            lowpriority[MARKDOWN_RULES.Space]
                        ])
                    }];
            })
        },
        // lists
        [MARKDOWN_RULES.OrderedList]: {
            exec: (input, lexer) => match(input, OLIST, arr => {
                const raw = arr[0], items = raw.replace(/^ {0,3}/gm, '').split(LISTITEM).filter(i => !NullChecker.isNullOrEmpty(i)).map(i => i.trim());
                return [{
                        type: MARKDOWN_TYPES.OrderedList, start: parseInt(/\d/.exec(arr[0])[0]), raw, text: raw, tokens: items.map(i => {
                            // avoid paragraphs if not strictly needed
                            return {
                                type: MARKDOWN_TYPES.ListItem, raw: i, text: i, tokens: tokenizeListItem(i, lexer)
                            };
                        })
                    }];
            })
        },
        [MARKDOWN_RULES.UnorderedList]: {
            exec: (input, lexer) => match(input, ULIST, arr => {
                const raw = arr[0], items = raw.replace(/^ {0,3}/gm, '').split(LISTITEM).filter(i => !NullChecker.isNullOrEmpty(i)).map(i => i.trim());
                return [{
                        type: MARKDOWN_TYPES.UnorderedList, raw, text: raw, tokens: items.map(i => {
                            return {
                                type: MARKDOWN_TYPES.ListItem, raw: i, text: i, tokens: tokenizeListItem(i, lexer)
                            };
                        })
                    }];
            })
        }
    };
    const blockRules = Object.values(block);
    Array.prototype.push.apply(blockRules, blockExtra);
    blockRules.push(lowpriority[MARKDOWN_RULES.Paragraph], lowpriority[MARKDOWN_RULES.Space]);
    // #endregion
    return [
        // comment first
        inert[MARKDOWN_RULES.Comment],
        inert[MARKDOWN_RULES.Reference]
    ].concat(
    // block rules contain recursive inline rules (at least)
    blockRules);
}
// #region HTML RENDERER HELPER
// meant to help in unnecessary spaces replacement.
const CARRIAGE_RETURN_PLACEHOLDER = '\0';
const TRIM_INSIDE = /[ \r\n]*\0+[ \r\n]*/g;
function trim(input) {
    return input?.replace(TRIM_INSIDE, '\n').trim();
}
// #endregion
class HtmlRenderer {
    constructor(_extraItemRender = (token, __) => token?.text || '') {
        this._extraItemRender = _extraItemRender;
        this._renderContent = (token) => {
            const children = token.tokens;
            if (NullChecker.isNullOrEmpty(children)) {
                return token.text;
            }
            return this._render(children);
        };
    }
    _rendeItem(token, allTokens) {
        const r = this._renderContent, R = CARRIAGE_RETURN_PLACEHOLDER;
        switch (token?.type) {
            case MARKDOWN_TYPES.Reference:
                return '';
            case MARKDOWN_TYPES.Html:
                return token.raw;
            case MARKDOWN_TYPES.BlockQuote:
                return `<blockquote>\n${r(token)}</blockquote>${R}`;
            case MARKDOWN_TYPES.Bold:
                return `<b>${r(token)}</b>`;
            case MARKDOWN_TYPES.CodeBlock:
                const lang = token['lang'];
                return `<pre>${R}<code${(lang ? (' class="' + lang + '"') : '')}>${r(token)}</code>${R}</pre>${R}`;
            case MARKDOWN_TYPES.Code:
                return `<code>${r(token)}</code>`;
            case MARKDOWN_TYPES.HorizontalRule:
                return `<hr />${R}`;
            case MARKDOWN_TYPES.Heading:
                const hlevel = token['level'], hid = token['ref'];
                return `<h${hlevel} id="${hid}">${r(token)}</h${hlevel}>${R}`;
            case MARKDOWN_TYPES.Image:
            case MARKDOWN_TYPES.ImageLike:
                const itk = token;
                let isrc = itk.src, ititle = '';
                const alt = itk.text, iref = itk.ref;
                if (!isrc && iref) {
                    const ireftk = allTokens.find(t => t.type === MARKDOWN_TYPES.Reference && t['image'] === true && t['id']?.toLowerCase() === iref.toLowerCase());
                    if (ireftk) {
                        isrc = ireftk.url;
                        ititle = ireftk.title ?? '';
                    }
                }
                return isrc ? `<img src="${isrc}" alt="${alt}"${(ititle ? (' title="' + ititle + '"') : '')} />` : `![${r(token)}]`;
            case MARKDOWN_TYPES.Italic:
                return `<i>${r(token)}</i>`;
            case MARKDOWN_TYPES.StrikeThrough:
                return `<s>${r(token)}</s>`;
            case MARKDOWN_TYPES.Quote:
                return `<q>${r(token)}</q>`;
            case MARKDOWN_TYPES.LineBreak:
                return '<br />' + R;
            case MARKDOWN_TYPES.OrderedList:
                return `<ol start="${token['start']}">\n${r(token)}</ol>${R}`;
            case MARKDOWN_TYPES.UnorderedList:
                return `<ul>\n${r(token)}</ul>${R}`;
            case MARKDOWN_TYPES.ListItem:
                return `\t<li>${r(token)}</li>${R}`;
            case MARKDOWN_TYPES.Link:
            case MARKDOWN_TYPES.LinkLike:
                const atk = token;
                let ahref = atk.href, atitle = '';
                const aref = atk.ref;
                if (!ahref && aref) {
                    const areftk = allTokens.find(t => t.type === MARKDOWN_TYPES.Reference && t['image'] !== true && t['id']?.toLowerCase() === aref.toLowerCase());
                    if (areftk) {
                        ahref = areftk.url;
                        atitle = areftk.title ?? '';
                    }
                }
                return ahref ? `<a href="${ahref}"${(atitle ? (' title="' + atitle + '"') : '')}>${r(token)}</a>` : `[${r(token)}]`;
            case MARKDOWN_TYPES.Paragraph:
                return `<p>${r(token)}</p>${R}`;
            case MARKDOWN_TYPES.Text:
            case MARKDOWN_TYPES.Space:
                return token.text;
        }
        return this._extraItemRender(token, allTokens);
    }
    _render(tree) {
        let acc = '';
        for (let token of tree || []) {
            acc += this._rendeItem(token, tree);
        }
        return acc;
    }
    render(tree) {
        return trim(this._render(tree));
    }
}
class TokenRenderer {
    _render(token) {
        return NullChecker.isNullOrEmpty(token) ? '' : JSON.stringify(token);
    }
    render(tree) {
        return '[' + tree.filter(i => !NullChecker.isNullOrEmpty(i)).map(this._render).join(',') + ']';
    }
}
function isRenderer(obj) {
    return obj && typeof obj === 'object' && typeof obj.render === 'function';
}
export class Parser extends Compile.Parser {
    toHtml(input, extraGrammar, extraItemRenderer) {
        const renderer = new HtmlRenderer(extraItemRenderer);
        if (NullChecker.isNullOrEmpty(extraGrammar)) {
            return this.parse(input, renderer);
        }
        return this.parse(input, getGrammar(extraGrammar), renderer);
    }
    tokenize(input, extraGrammar) {
        const json = this.parse(input, getGrammar(extraGrammar), new TokenRenderer());
        return JSON.parse(json);
    }
    parse(input, grammarOrRenderer = getGrammar(), renderer = new HtmlRenderer()) {
        if (isRenderer(grammarOrRenderer)) {
            return super.parse(input, getGrammar(), grammarOrRenderer);
        }
        else {
            return super.parse(input, grammarOrRenderer, renderer);
        }
    }
}
//}
